import { supabase } from "../supabaseClient";

//* Auth
async function authSignUp(postData) {
  return await supabase.auth.signUp(postData);
}


//* Users table
async function insertUser(postBody) {
  return await insertQuery("Users", postBody).select("*").maybeSingle();
}
//* Update Auth 
async function authUpDateSignUp(postData) {
  return await supabase.auth.api.updateUser(JSON.parse(localStorage.getItem('supabase.auth.token')).currentSession.access_token , postData);
}

async function getUserByUserId(userId) {
  return await supabase
    .from("Users")
    .select("*")
    .eq("userId", userId)
    .maybeSingle();
}
async function getUserByEmailId(emailId) {
  const { data, error } = await supabase
    .from("Users")
    .select("*")
    .eq("email", emailId);
  if (data) return data;
  else throw error;
}
// async function getUserByUserName(name) {
//   return await supabase
//     .from('Users')
//     .select(`*, roleId(title, accessibleTabs), parentId(name)`, { count: 'exact' })
//     .ilike('name', '%' + name + '%');
// }

function UploadCrmUserDoc(fileObject, fileName) {
  console.log({ fileObject, fileName });
  return new Promise(async (resolve, reject) => {
    let uploadResponse = await supabase.storage.from("crmusers").upload(fileName, fileObject, { upsert: true });
    if (uploadResponse.data) {
      console.log("uploadResponse.data => ", uploadResponse.data);
      const _url = supabase.storage.from("crmusers").getPublicUrl(fileName).data.publicURL;
      resolve({ success: true, url: _url });
    } else {
      resolve({ success: false, error: uploadResponse?.error });
    }
  })
}

async function deleteCrmUserDoc(fileName) {
     const { data, error } = await supabase.storage.from('crmusers').remove([fileName])
    if (data) return data;
    else throw error;
}


async function getUser(name, roleId,drpDownSelectedVal) {

  const UsersFilters = {
    "Name Ascending": {
      key: 'name',
      isAscending: true
    },
    "Name Descending": {
      key: 'name',
      isAscending: false
    },
    "Oldest First": {
      key: 'created_at',
      isAscending: true
    },
    "Latest First": {
      key: 'last_updated_at',
      isAscending: false
    }
  }
  let query = supabase
    .from("Users")
    .select(`*, roleId(title, accessibleTabs , level), parentId(name)`, {
      count: "exact",
    });


  if (name) {
    query = query.ilike("name", "%" + name + "%");
  }

  if (roleId && roleId != "all") {
    query = query.eq("roleId", roleId);
  }
  query= query.order(UsersFilters[drpDownSelectedVal].key, { ascending: UsersFilters[drpDownSelectedVal].isAscending });
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getUserByRole(role) {
  return await supabase
    .from("Users")
    .select("*")
    .textSearch("name", `${role}`, {
      type: "websearch",
      config: "english",
    });
}

async function updateUser(postBody, userId) {
  return await updateQuery("Users", postBody)
    .eq("userId", userId)
    .select("*")
    .maybeSingle();
}

async function getAllUsers(drpDownSelectedVal)  {
   console.log("drpDownSelectedVal" , drpDownSelectedVal)
  const UsersFilters = {
    "Name Ascending": {
      key: 'name',
      isAscending: true
    },
    "Name Descending": {
      key: 'name',
      isAscending: false
    },
    "Oldest First": {
      key: 'created_at',
      isAscending: true
    },
    "Latest First": {
      key: 'last_updated_at',
      isAscending: false
    }
  }

  let query = supabase
    .from("Users")
    .select(`*, roleId(title, accessibleTabs , level), parentId(name)`, { count: "exact",})
    .order(UsersFilters[drpDownSelectedVal].key, { ascending: UsersFilters[drpDownSelectedVal].isAscending });
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getUserByRoleName(roleId) {
  let query = supabase
    .from("Users")
    .select(`*, roleId(title, accessibleTabs), parentId(name)`, {
      count: "exact",
    })
    .eq("roleId", roleId);
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getCRMUsersFromUserTable() {
  let query = supabase
    .from("Users")
    .select(`*`, { count: "exact" })
    .eq("isCrmUser", true)
    .eq("isActive", true);
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
async function getCRMUserFromCRMTable() {
  let query = supabase.from("CRM").select(`*`, { count: "exact" });
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
async function insertToCRMTable(obj) {
  const { data, error } = await supabase.from("CRM").insert(obj);
  if (data) return data;
  else throw error;
}
async function updateToCRMTable(crmUserId, allotmentPaymentId) {
  const { data, error } = await supabase.from("CRM").update({crmUserId : crmUserId}).eq("allotmentPaymentId", allotmentPaymentId);
  if (data) return data;
  else throw error;
}
async function updateUnitCostAllotmentPaymentById(obj, id) {
    const { data, error, count } = await supabase
      .from("AllotmentPayment")
      .update(obj)
      .eq("allotmentPaymentId", id);
    if (data) return { data };
    else throw error;
}


async function getPreselectConfirmationsConfig(eventId, eventTokenId, launchId) {
  const { data, error, } = await supabase.from('PreselectConfirmationConfig').select('*')
      .eq('eventId', eventId)
      .eq('eventTokenId', eventTokenId)
      .eq("launchId", launchId)
  if (data) return { data };
  else throw error;
}



async function checkUserEmailExists(email) {
  const { data, error } = await supabase
  .from('Users')
  .select('email')
  .eq('email', email);
if (data) return data;
else throw error;
}

//* BlacklistNumbers — Users-table rows are scoped by userId (cpId/fosId/vjopId
// stay null). number is expected WITH country code, no "+" (e.g. "919876543210"),
// same convention isPhoneNumberValid() already enforces on user.contactNumber.
async function isNumberBlacklisted(number) {
  const { data, error } = await supabase
    .from('BlacklistNumbers')
    .select('number')
    .eq('number', number);
  if (data) return data;
  else throw error;
}

async function insertBlacklistedPhoneNumber(userId, number) {
  return await supabase.from('BlacklistNumbers').insert([{ userId, number }]);
}

async function deleteBlacklistedPhoneNumber(number) {
  return await supabase.from('BlacklistNumbers').delete().eq('number', number);
}

// Checks first and only inserts if the number isn't already claimed by
// someone else. Never throws -- a blacklist hiccup must not block a Users
// create/update.
async function addUserToBlacklistIfAbsent(userId, number) {
  try {
    const existing = await isNumberBlacklisted(number);
    if (existing.length > 0) return;
    const { error } = await insertBlacklistedPhoneNumber(userId, number);
    if (error) console.error('addUserToBlacklistIfAbsent insert failed', error);
  } catch (err) {
    console.error('addUserToBlacklistIfAbsent failed', err);
  }
}


export {
  //* Auth
  authSignUp,

  //* Users table
  insertUser,
  getUserByUserId,
  getUserByRole,
  updateUser,
  getAllUsers,
  getUserByRoleName,
  getUser,
  getUserByEmailId,
  UploadCrmUserDoc,
  getCRMUsersFromUserTable,
  insertToCRMTable,
  getCRMUserFromCRMTable,
  deleteCrmUserDoc,
  checkUserEmailExists,
  isNumberBlacklisted,
  deleteBlacklistedPhoneNumber,
  addUserToBlacklistIfAbsent,
  authUpDateSignUp,
  getPreselectConfirmationsConfig,
  updateUnitCostAllotmentPaymentById,
  updateToCRMTable,
  getActiveApprover,
  reassignStuckApprovals,
  getPendingApprovalsByUser,
};

// !! NEW: getActiveApprover — finds active replacement if assigned user is inactive
async function getActiveApprover(assignedUserId) {
  if (!assignedUserId) return { data: null };
  const { data: assignedUser } = await supabase
    .from("Users")
    .select("userId, name, isActive, roleId, parentId")
    .eq("userId", assignedUserId)
    .maybeSingle();
  if (assignedUser?.isActive) return { data: assignedUser };
  const { data: replacements } = await supabase
    .from("Users")
    .select("userId, name, isActive, roleId(title)")
    .eq("roleId", assignedUser?.roleId)
    .eq("isActive", true)
    .neq("userId", assignedUserId)
    .limit(1);
  if (replacements?.[0]) return { data: replacements[0], wasReassigned: true };
  if (assignedUser?.parentId) {
    const { data: parentUser } = await supabase
      .from("Users")
      .select("userId, name, isActive, roleId(title)")
      .eq("userId", assignedUser.parentId)
      .eq("isActive", true)
      .maybeSingle();
    if (parentUser) return { data: parentUser, wasEscalated: true };
  }
  return { data: null };
}

// !! NEW: reassignStuckApprovals — bulk reassign from inactive user
async function reassignStuckApprovals(fromUserId, toUserId) {
  const { data, error } = await supabase
    .from("AllotmentPayment")
    .update({ requestPendingWith: toUserId, last_updated_at: Date.now() })
    .eq("requestPendingWith", fromUserId)
    .in("status", ["Cancellation Requested","Cancellation Pending","Awaiting Customer Response","Customer Response Overdue","Escalated by SM"]);
  if (error) throw error;
  return { data };
}

// !! NEW: getPendingApprovalsByUser — check before deactivating a user
async function getPendingApprovalsByUser(userId) {
  const { data, error } = await supabase
    .from("AllotmentPayment")
    .select("allotmentPaymentId, status, last_updated_at, leadId(name), unitId(unitNo, projectId(projectName))")
    .eq("requestPendingWith", userId)
    .in("status", ["Cancellation Requested","Cancellation Pending","Awaiting Customer Response","Customer Response Overdue","Escalated by SM"]);
  if (data) return { data };
  else throw error;
}

function updateQuery(tableName, postData) {
  let _postBody = { ...postData };
  _postBody.last_updated_at = Date.now();

  return supabase.from(tableName).update(_postBody);
}
function insertQuery(tableName, postData) {
  let _postBody = { ...postData };
  _postBody.last_updated_at = Date.now();

  return supabase.from(tableName).insert(_postBody);
}
